module.exports = __webpack_public_path__ + "media/corporate-image/mail-icon-d39cec0c30bff0bca611b2a84d2d45e3.png";